module.exports = __webpack_public_path__ + "img/Honig-aus-2021-1160.8a819fa0.jpg";